import { determineSelector, getResource, readUrl } from "./api";

// Single-row read of an expert's profile-completion score (the `expert_completion_scores`
// PostgREST view — keyed on the expert PromoEntity's id, not a profile id). Mirrors
// experts.js's `get` shape, minus the slug lookup: callers of this client already have the
// expert's numeric id in hand (it backs a decorative rail widget, not a page route).
const getById = async (expertId) => {
  const selector = determineSelector(expertId, { keyId: "id" });
  const url = readUrl("expert_completion_scores", { selector });
  return getResource(url);
};

export default { getById };
